import { useEffect } from "react";

// Paints the page body in the tenancy's chosen landing-page colour while the page is mounted, then
// restores whatever was there before so the rest of the app keeps its theme background.
export default function useLandingPageBackground(colour) {
    useEffect(() => {
        if (!colour) {
            return undefined;
        }
        const original = document.body.style.backgroundColor;
        document.body.style.backgroundColor = colour;
        return () => {
            document.body.style.backgroundColor = original;
        };
    }, [colour]);
}
